<!-- Base template for components -->
<template>
    <p-table
      :value="items" 
      paginator 
      :rows="5"
      showGridlines
      responsiveLayout="scroll"
      v-model:selection="selection"
      :rowsPerPageOptions="[5, 10, 20, 50]"
      v-model:filters="filters"
      :globalFilterFields="[name_column, '_id']"
      tableStyle="min-width: 50rem">
        <template #header>
             <div class="flex flex-wrap align-items-center justify-content-between gap-2">
                 <span class="text-xl text-900 font-bold">Trash</span>
                 <span class="flex-8 p-input-icon-left">
                    <p-iconfield>
                        <p-inputicon>
                            <i class="pi pi-search" />
                        </p-inputicon>
                        <p-text v-model="filters['global'].value" placeholder="Search" />
                    </p-iconfield>
                 </span>
                 <span>               
                     <p-button 
                         v-if="selection.length" 
                         @click="restore()"
                         title="restore"
                         icon="pi pi-undo" 
                         rounded raised 
                     />
                 </span>
             </div>
         </template>
         <template #empty> Trash Empty. </template>
         <template #loading> Loading Trash. Please wait. </template> 
          <p-column
             selectionMode="multiple"
             style="width: 3rem"
         ></p-column>
        <p-column field="_id" header="ID"></p-column>
        <p-column :field="name_column" header="Name"></p-column>
        <p-column 
             style="min-width: 8rem"
             header="Created At"
             sortField="created_at_time" :sortable="true">
             <template #body="slotProps">
                 <span v-if="slotProps.data.created_at">
                     {{ new Date(slotProps.data.created_at).toLocaleString("en-IN") }}
                 </span>
             </template>
         </p-column>
         <p-column 
             style="min-width: 8rem"
             header="Updated At"
             sortField="updated_at_time" :sortable="true">
             <template #body="slotProps">
                 <span v-if="slotProps.data.updated_at">
                     {{ new Date(slotProps.data.updated_at).toLocaleString("en-IN") }}
                 </span>
             </template>
             </p-column>
              <p-column 
                   style="min-width: 8rem"
               >
             <template #body="slotProps">
                 <p-button icon="pi pi-eye" @click="edit(slotProps.data)" rounded raised />
             </template>
         </p-column>
     </p-table>
</template>
 
<script lang="ts">
import { Options } from 'vue-class-component';
import { base } from "../misc/base";

@Options({
   props: {
       items: Array,
       name_column : String
   },
   emits: ["onEdit", "onRestore"],
})
export default class Trash extends base {
   selection : any[] = []
   items! : any[]
   name_column! : string

   filters = {
     'global' : {
       value : ""
     }
   }


   edit(row : any){
       this.$emit("onEdit", row)
   }

   async restore(){

       let reqIds = []

       for(const row of this.selection){
           reqIds.push(row._id)
       }

       try {

           const service = this.store.state.simforce
           await service.post(
               `/approve/restore`,
               reqIds,
           )

           this.$emit("onRestore", reqIds)
           this.selection = []
           this.handleSuccess("Success!", "Items restored")

       } catch(e){
           this.handleError(e)
       }
   }

}
</script>
 
 <!-- Add "scoped" attribute to limit CSS to this component only -->
 <style scoped>
 
 </style>
 